import {createSelector} from 'reselect';

import {AppState} from '../../../../../verticals/hotels-dweb/src/shared/store';

export const srpUnifSelector = (state: AppState) => state.srpUnif;

/* ------- SRP Selectors ------- */
export const srpCGDataSelector = createSelector(srpUnifSelector, items => items);

export const hasCGSRPDataSelector = createSelector(srpUnifSelector, items => items?.hasSRPData);

export const isDatelessSeoSelector = createSelector(srpUnifSelector, items => items?.isDatelessSeo);

export const srpSrpConfigDataSelector = createSelector(
  srpCGDataSelector,
  item => item?.srpConfig || {},
);

export const selectedHotelItemDataSelector = createSelector(
  srpCGDataSelector,
  item => item?.selectedHotelItemData,
);

export const searchHotelsRequestStateSelector = createSelector(
  srpCGDataSelector,
  item => item?.searchHotelsRequestState || {},
);

/* ------------ mob-landing selector --------------*/
export const srpMobLandingDataSelector = createSelector(
  srpCGDataSelector,
  item => item?.mobLandingData,
);

export const mobLandingCardSelector = createSelector(
  srpMobLandingDataSelector,
  mobLandingData => mobLandingData?.listPersonalizationResponse?.cardData || [],
);

export const srpMatchMakerDataSelector = createSelector(
  srpMobLandingDataSelector,
  mobLandingData => mobLandingData?.matchMakerResponse || {},
);

export const srpMobLandingUuidSelector = createSelector(
  srpMobLandingDataSelector,
  mobLandingData => mobLandingData?.uuids || [],
);

export const srpMobLandingSmartEngageSelector = createSelector(
  srpMobLandingDataSelector,
  mobLandingData => mobLandingData?.smartEngageResponse || {},
);

export const smartEngageOffersCardsSelector = createSelector(
  srpMobLandingSmartEngageSelector,
  smartEngageResponse => smartEngageResponse?.data?.slots?.hotels_srp_app || [],
);

/* -------------- similar properties selector --------------*/

export const similarHotelsSelector = createSelector(
  srpCGDataSelector,
  item => item?.similarHotels || {},
);

export const similarHotelsStatusSelector = createSelector(
  srpCGDataSelector,
  item => item?.similarHotelsRequestState,
);

/* -------------- filter data selector --------------*/
export const filterDataSelector = createSelector(srpCGDataSelector, item => item?.filterData);

export const filterDataStatusSelector = createSelector(
  srpCGDataSelector,
  item => item?.filterDataRequestStatus,
);
